var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2524_19372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4167 7.24999L24.7667 11.9C24.2334 12.4333 24.6001 13.3333 25.3501 13.3333H28.3334V24.8C28.3334 26.4667 27.2167 28.0167 25.5667 28.2833C23.4834 28.6333 21.6667 27.0167 21.6667 25V13.6167C21.6667 10.1333 19.1167 7.03333 15.6501 6.69999C11.6834 6.31666 8.33338 9.43333 8.33338 13.3333V25H5.35005C4.60005 25 4.23338 25.9 4.76672 26.4167L9.41672 31.0667C9.75005 31.4 10.2667 31.4 10.6001 31.0667L15.2501 26.4167C15.7667 25.9 15.4001 25 14.6501 25H11.6667V13.5333C11.6667 11.8667 12.7834 10.3167 14.4334 10.05C16.5167 9.69999 18.3334 11.3167 18.3334 13.3333V24.7167C18.3334 28.2 20.8834 31.3 24.3501 31.6333C28.3167 32.0167 31.6667 28.9 31.6667 25V13.3333H34.6501C35.4001 13.3333 35.7667 12.4333 35.2334 11.9167L30.5834 7.26666C30.2667 6.93333 29.7334 6.93333 29.4167 7.24999V7.24999Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2524_19372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailLength);
export default __webpack_public_path__ + "static/media/detail-length.b649e2adbe3634efc911f3a2ce54a04e.svg";
export { ForwardRef as ReactComponent };